import React from 'react';
import { Row, Col } from 'antd';
import { SVGParallelogram } from './SVGParallelogram';

const ApplicationsAccessories = ({ product_application, product_accessory }) => {
    return (
        <div style={styles.container}>
            <Row gutter={0}>
                {/* Applications Section */}
                {product_application?.length > 0 &&
                    <Col span={12} style={styles.leftSection}>
                        <div style={styles.sectionHeader}>
                            <SVGParallelogram skewAmount={42} width={475} style={styles.sectionTitle}>
                                APPLICATIONS
                            </SVGParallelogram>
                        </div>
                        <div style={styles.contentArea}>
                            {product_application?.map((app, index) => (
                                <div key={index} style={{ ...styles.applicationItem }}>
                                    <div style={styles.iconContainer}>
                                        <div style={styles.icon}>
                                            {/* {app.icon} */}
                                        </div>
                                    </div>
                                    <div style={styles.textContent}>
                                        <h3 style={styles.itemTitle}>{app.heading}</h3>
                                        <p style={styles.itemDescription}>{app.application}</p>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </Col>}

                {/* Optional Accessories Section */}
                {product_accessory?.length > 0 && <Col span={12} style={styles.rightSection}>
                    <div style={styles.accessoriesHeader}>
                        <h2 style={styles.accessoriesTitle}>OPTIONAL ACCESSORIES</h2>
                    </div>
                    <div style={styles.accessoriesContentArea}>
                        {product_accessory?.map((accessory, index) => (
                            <div key={index} style={styles.accessoryItem}>
                                <div style={styles.bullet}></div>
                                <div style={styles.textContent}>
                                    <h3 style={styles.accessoryItemTitle}>{accessory.heading}</h3>
                                    <p style={styles.itemDescription}>{accessory.accessory}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                </Col>}
            </Row>
        </div>
    );
};

const styles = {
    container: {
        backgroundColor: '#ffffff',
        margin: '0',
        width: "100%",
        padding: '10px',
        fontFamily: 'Manrope, sans-serif',
        fontWeight: 500,
    },
    leftSection: {
        backgroundColor: '#ffffff',
        padding: '0'
    },
    rightSection: {
        backgroundColor: 'rgba(242, 242, 242, 1)',
        padding: '0'
    },
    sectionHeader: {
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        paddingBottom: '60px',
    },
    sectionTitle: {
        color: "white",
        fontSize: "46px",
        margin: "0",
        backgroundColor: "#0C3C78",
        padding: "15px",
        position: "relative",
        zIndex: 2,
        fontFamily: 'Lexend, sans-serif',
        fontWeight: 700,
        letterSpacing: '0%'
    },
    accessoriesHeader: {
        backgroundColor: 'rgba(242, 242, 242, 1)',
        padding: '20px 35px',
        height: '60px',
        display: 'flex',
        alignItems: 'center'
    },
    accessoriesTitle: {
        color: '#1e3a5f',
        fontSize: '42px',
        margin: '0',
        letterSpacing: '1px',
        fontFamily: 'Lexend, sans-serif',
        fontWeight: 700,
    },
    contentArea: {
        paddingTop: '40px',
        padding: '20px 15px',
        backgroundColor: 'transparent'
    },
    accessoriesContentArea: {
        padding: '40px',
        backgroundColor: 'rgba(242, 242, 242, 1)'
    },
    applicationItem: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '60px',
        gap: '30px'
    },
    iconContainer: {
        flexShrink: 0,
        paddingLeft: '10px',
    },
    icon: {
        width: '24px',
        height: '24px',
        borderRadius: '50%',
        backgroundColor: '#00bcd4',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        fontSize: '16px',
        color: 'white'
    },
    textContent: {
        flex: 1,
        backgroundColor: 'transparent'
    },
    itemTitle: {
        color: '#0C3C78',
        fontSize: '28px',
        fontWeight: 'bold',
        margin: '0 0 8px 0',
        lineHeight: '1.2'
    },
    itemDescription: {
        color: '#5A667A',
        fontSize: '18px',
        margin: '0',
        letterSpacing: '0%',
        paddingTop: '12px'
    },
    accessoryItem: {
        display: 'flex',
        alignItems: 'center',
        marginBottom: '20px',
        gap: '20px',
        backgroundColor: 'white',
        padding: '39px',
        boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)'
    },
    bullet: {
        width: '16px',
        height: '16px',
        borderRadius: '50%',
        backgroundColor: '#00bcd4',
        display: 'flex',
        flexShrink: 0,
        alignItems: 'center',
        justifyContent: 'center',
    },
    accessoryItemTitle: {
        color: '#0C3C78',
        fontSize: '24px',
        fontWeight: 700,
        margin: '0 0 6px 0',
        lineHeight: '1.2'
    }
};

export default ApplicationsAccessories;